// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 9774) return "static/chunks/framework-afa03e9e173d7332.js";
	// return url for filenames based on template
	return "static/chunks/" + ({"1954":"5c55bf5d","9525":"a4077e0c"}[chunkId] || chunkId) + "." + {"905":"db3d886d5fdbfa9b","1954":"323218bf401b741c","6667":"fcd5c7a15444f4a6","7529":"cf5f1931e4ea0064","9525":"1cf79e68f06733b2"}[chunkId] + ".js";
};